import * as React from 'react';
import { connect } from 'react-redux';

import './Main.scss';

import { ApplicationState } from '../Store';
import { GetStrongboxHelpCenterLink } from '../Store/AppSettings';
import { GetPortalText } from '../Store/PortalAssets';

import { PortalTextCommon } from '../Models/Api/strongbox.financialportal';

export const portalFooterId = 'strongboxPortalFooter';

type InjectedReduxState = {
    helpCenterLink: string;
    commonText?: PortalTextCommon;
};

type InjectedActionCreators = {
};

type PortalFooterProps = {
    contentOverride?: React.ReactElement;
};

type Props = InjectedReduxState & InjectedActionCreators & PortalFooterProps;

const PortalFooterComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        contentOverride,
        helpCenterLink,
        commonText,
    } = props;

    return (
        <div id={portalFooterId} className={`portal-footer-container`}>
            <div className={`portal-footer-region`}>
                {!contentOverride && (
                    <React.Fragment>
                        {!!commonText && (
                            <React.Fragment>
                                <span>
                                    {commonText?.portalFooterNeedHelpVisit || ''}&nbsp;
                                    <a href={helpCenterLink} target={'_blank'} rel={'noopener noreferrer'}>{commonText?.portalFooterHelpCenter || ''}</a>
                                    &nbsp;{commonText?.portalFooterForAssistance || ''}
                                </span>
                                <span>{commonText?.portalCopyright || ''}</span>
                            </React.Fragment>
                        )}
                        {!commonText && (
                            <React.Fragment />
                        )}
                    </React.Fragment>
                )}
                {!!contentOverride && contentOverride}
            </div>
        </div>
    );
}

export const PortalFooter = connect<InjectedReduxState, InjectedActionCreators, PortalFooterProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result: InjectedReduxState = {
            helpCenterLink: GetStrongboxHelpCenterLink(appState) || '',
            commonText: GetPortalText(appState, 'commonText'),
        };

        return result;
    },
)(PortalFooterComponent);
